import { useState, useEffect } from 'react';
import gql from 'not-graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  PremiseSearchRequest,
  PremiseSearchResponse,
} from '../__generated__/pge-types';

const PREMISE_SEARCH_QUERY = gql`
  query PremiseSearch($payload: PremiseSearchRequest) {
    premiseSearch(payload: $payload) {
      premId
      spList {
        spId
        spType
        spDesc
        geolocation
        locationCode
        locationDesc
        meterNumber
        spStatus
        isResAreaLight
      }
    }
  }
`;

interface Response {
  premiseSearch: PremiseSearchResponse[];
}

interface Request {
  payload: PremiseSearchRequest;
}

export const usePremiseSearchQuery = () => {
  const [premiseIds, setPremiseIds] = useState<string[]>();
  const [premiseSearch, { loading, data, error }] = useLazyQuery<
    Response,
    Request
  >(PREMISE_SEARCH_QUERY);

  useEffect(() => {
    if (premiseIds) {
      premiseSearch({
        variables: { payload: { premList: premiseIds } },
      });
    }
  }, [premiseIds]);

  return {
    premiseIds,
    setPremiseIds,
    loading,
    error,
    data,
  };
};
